import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators } from '@angular/forms';
import { DegreeRatesDto, DegreeModel, AttestationModel, CopiesTypeModel, degreeInfo, DegreeModelList } from './model/attestationModel';
import { AttestationDetailsService } from './services/attestation-details.service';
import { HecResponse } from '../../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { CommonHelper } from '../../../../../utilities/common.helper';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';
import { GoogleAnalyticsService } from '../../../../../shared/sharedServices/google-analytics.service';
import { decrypt } from '../../../../../utilities/utilityFunctions';
import { PucaDataService } from '../../services/puca-data.service';
import { PucaComponent } from '../../puca.component';

@Component({
  selector: 'kt-attestation-details',
  templateUrl: './attestation-details.component.html',
  styleUrls: ['./attestation-details.component.scss']
})
export class AttestationDetailsComponent implements OnInit, OnDestroy {
  @Input('dasApplicationData') dasApplicationData: AttestationModel = new AttestationModel();
  public trst: AttestationModel = new AttestationModel();
  @Input('dropdownValuesForDas') dropdownValuesForDas: any;
  public degreeAttestationForm: FormGroup;
  public localDegreeDocumentList: any = [];
  public internationalDegreeDocumentList: any = [];
  public step: number = 0;
  public attestationRates: any;
  public totalAmountForDegrees: any = [];
  public amountForDegrees: any = [];
  public amountForDegreeInt: any = [];
  public totalForLocal: any = 0;
  public totalForInt: any = [];
  public educationHistoryData: any = [];
  public attestationData: any = [];
  public degreeData: any = []
  public isAttestationValid: boolean = false;
  public isError: any = [];
  public alertType: string;
  public errorMsg: string;
  public degreeStatus: any = [];
  public duplicateStatus: any = [];
  public isDegreeVerified: any = [];
  public showAttestedCase: boolean = false;
  public applicationTypes: any = [];
  public reginalCenterList: any = [];
  public degreeStampVerified: any = [];
  public loader: boolean = false
  public formView: string = '';
  public backNextCase: any;
  public inCompleteOrEnrolledDocumentList: any = []
  public isEducationCurrentlyEnrolled: any = []
  public isEducationInComplete: any = []
  public isInternationalEducation: any = [];
  public isIphone:boolean;
  public attestationMode:any;
  public isInsidePakistanSelected:any;
  public regionalselected:number = 1;
  public districtList:any;
  public regionalCenterByDistrict:any;
  public searchCtrl:string = '';
  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef, private attestationService: AttestationDetailsService,
    private parentComp: PucaComponent, private matDialog: MatDialog, private router: Router, private dasDataService: PucaDataService,
    private loaderService: LoaderService,private gaService:GoogleAnalyticsService,) {
    this.educationHistoryData = JSON.parse(decrypt(localStorage.getItem('eduHistory')));
    if(decrypt(localStorage.getItem('agent'))!='desktop'){
      this.isIphone = true;
    }
  }

  ngOnInit() {
    window.scroll(0,0)
    this.gaService.setPage('/form','ESP Page');
    this.backNextCase = this.parentComp.backCase;
    this.formView = this.parentComp.formType;
    this.applicationTypes = this.dropdownValuesForDas.appTypeList;
    this.reginalCenterList = this.dropdownValuesForDas.regionalCenterList.map(item => {
      return {
        label: item.regionalCentreName,
        value: item.id
      };
    });
    //forLocalEducationList
    this.localDegreeDocumentList = this.dropdownValuesForDas.map['6005'];
    //for International Education List
    this.internationalDegreeDocumentList.push(this.dropdownValuesForDas.map['6005'][3])
    //for incomplete or currently enrolled Education List
    this.inCompleteOrEnrolledDocumentList.push(this.dropdownValuesForDas.map['6005'][1])
    //attestaionRates
    this.attestationRates = this.dropdownValuesForDas.attestationRates;
    this.createDegreeAttestationForm();

    for (let i = 0; i < this.dasApplicationData.dasApplicationDto.dasDegrees.length; i++) {

      this.amountForDegrees.push(new DegreeModel());
      this.getDegreeList();
      //-----------------------------------------------//
      //for local complete education
      if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.countryId == 1 &&
        !this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isIncompleteEducation &&
        !this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.currentEnrolmentInd &&
        !this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isCAUniversity) {
        this.localDegreeDocumentList = this.dropdownValuesForDas.map['6005'];
        for (let k = 0; k < this.localDegreeDocumentList.length; k++) {
          this.getAttestationList(i, this.localDegreeDocumentList[k].value, this.dasApplicationData.dasApplicationDto.dasDegrees[i]);
          this.amountForDegrees[i].degreeList.push(new DegreeModelList())
        }
        //unverified/new education
        if (!this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified &&
          this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo.length == 0) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.disable();
        }

        //
        if (!this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified && !this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isPartiallyAttested &&
          this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo.length == 0 || this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo.length) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.disable();
        }

        //transcript verified/is partially attested case
        if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isPartiallyAttested &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[1].controls.photocopyPages.enable();
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[1].controls.originalPages.enable();
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[2].controls.photocopyPages.enable();
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[2].controls.originalPages.enable();
        }

      }
      ///------------///
      //-----------------------------------------------//
      //for local currently Enrolled education
      if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.countryId == 1 && this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.currentEnrolmentInd &&
        this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isCAUniversity == false) {
        for (let k = 0; k < this.inCompleteOrEnrolledDocumentList.length; k++) {
          this.getAttestationList(i, this.inCompleteOrEnrolledDocumentList[k].value, this.dasApplicationData.dasApplicationDto.dasDegrees[i]);
          this.amountForDegrees[i].degreeList.push(new DegreeModelList())
        }
        //unverified/new education only for enrolled case
        if (!this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified &&
          this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo.length == 0) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.disable();

          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[0].controls.originalPages.enable();
          // this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[0].controls.photocopyPages.disable();
        }
        //transcript verified/is partially attested case
        if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isPartiallyAttested &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[0].controls.photocopyPages.enable();
        }
      }
      //-----------------------------------------------//
      //for local incomplete education
      if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.countryId == 1 && this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isIncompleteEducation &&
        this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isCAUniversity == false) {

        for (let k = 0; k < this.inCompleteOrEnrolledDocumentList.length; k++) {
          this.getAttestationList(i, this.inCompleteOrEnrolledDocumentList[k].value, this.dasApplicationData.dasApplicationDto.dasDegrees[i]);
          this.amountForDegrees[i].degreeList.push(new DegreeModelList())
        }
        //unverified/new education only for incomplete case
        if (!this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified &&
          this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo.length == 0) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.disable();

          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[0].controls.originalPages.enable();
          // this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[0].controls.photocopyPages.disable();
        }
        //transcript verified/is partially attested case
        if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isPartiallyAttested &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[0].controls.photocopyPages.enable();
        }
      }
      //-----------------------------------------------//
      //for CA Cases
      if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.countryId == 1 && this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isCAUniversity) {
        this.localDegreeDocumentList = this.internationalDegreeDocumentList
        for (let k = 0; k < this.localDegreeDocumentList.length; k++) {
          this.getAttestationList(i, this.localDegreeDocumentList[k].value, this.dasApplicationData.dasApplicationDto.dasDegrees[i]);
          this.amountForDegrees[i].degreeList.push(new DegreeModelList())
        }
        //unverified/new education only for incomplete case
        if (!this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified &&
          this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo.length == 0) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.disable();

        }
        //transcript verified/is partially attested case
        if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isPartiallyAttested == true &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[0].controls.photocopyPages.enable();
        }
      }
      //-----------------------------------------------//
      //for International Education Cases
      else if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.countryId != 1) {

        for (let k = 0; k < this.internationalDegreeDocumentList.length; k++) {
          this.getAttestationList(i, this.internationalDegreeDocumentList[k].value, this.dasApplicationData.dasApplicationDto.dasDegrees[i]);
          this.amountForDegrees[i].degreeList.push(new DegreeModelList())
        }
        //for new and unverified
        if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo.length == 0 &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.disable();
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[0].controls.originalPages.enable();

        }
        if (this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.isIncompleteEducation &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified) {
          this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.enable();

        }
      }
      //-----------------------------------------------//
    }
    this.setDataAttestationFormData();
    //-----------------------------------------------//
    //form readonly case
    if (this.formView == 'view') {
      setTimeout(() => {
        this.degreeAttestationForm.disable()
      }, 500);
    }
    //-----------------------------------------------//
  }

  ngOnDestroy() {
    this.dasDataService.formView = undefined;
    this.dasDataService.applicationId = undefined;
  }

  public goBack() {
    this.parentComp.goBack();
    this.cdr.detectChanges();
  }

  public goNext() {
    this.parentComp.goNext();
    this.cdr.detectChanges();
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    if (this.formView != 'view') {
      this.isAttestationValid = false;
      this.step++;
      //-----------------------------------------------//
      //disabled next form on conditional cases
      if (!this.dasApplicationData.dasApplicationDto.dasDegrees[this.step].educationHistoryDto.verified && !this.degreeStampVerified[this.step] &&
        this.dasApplicationData.dasApplicationDto.dasDegrees[this.step].degreeInfo.length == 0 &&
        this.dasApplicationData.dasApplicationDto.dasDegrees[this.step].educationHistoryDto.currentEnrolmentInd &&
        this.dasApplicationData.dasApplicationDto.dasDegrees[this.step].educationHistoryDto.isIncompleteEducation) {
        this.degreeAttestationForm.controls.degreeList['controls'][this.step]['controls'].degree.disable();
      } else if (!this.dasApplicationData.dasApplicationDto.dasDegrees[this.step].educationHistoryDto.verified &&
        this.dasApplicationData.dasApplicationDto.dasDegrees[this.step].degreeInfo.length == 0 &&
        (this.dasApplicationData.dasApplicationDto.dasDegrees[this.step].educationHistoryDto.currentEnrolmentInd ||
          this.dasApplicationData.dasApplicationDto.dasDegrees[this.step].educationHistoryDto.isIncompleteEducation)) {
        this.degreeAttestationForm.controls.degreeList['controls'][this.step]['controls'].degree.controls[0].controls.originalPages.enable();
      }
    } else {
      this.step++;
    }
  }

  prevStep() {
    this.step--;
  }

  public getDate(date): any {
    let convertedDate = new Date(date).toISOString();
    return convertedDate;
  }

  private createDegreeAttestationForm(): void {
    this.degreeAttestationForm = this.fb.group({
      regionalCentreId: new FormControl(null),
      attestationMode: new FormControl(null, [Validators.required]),
      isInsidePakistan:new FormControl(),
      districtId:new FormControl(),
      searchCtrl:new FormControl(),
      degreeList: this.fb.array([
      ]),
    })
  }

  public getDegreeList() {
    const degreesList = this.degreeAttestationForm.controls.degreeList as FormArray;
    let newRow = this.fb.group({
      isDegreeAttestedBefore: new FormControl(null),
      isDegreeDuplicateCase: new FormControl(null),
      stampNumber: new FormControl(null),
      degree: new FormArray([])
    });
    degreesList.push(newRow);
  }

  public getAttestationList(index, documentValue, degreeData) {
    const attestationlist = this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree as FormArray;
    let newRow = this.fb.group({
      eduId: new FormControl(degreeData.cpEducationHistoryId),
      degreeId: new FormControl(),
      originalPages: new FormControl(0, [Validators.required]),
      photocopyPages: new FormControl(0, [Validators.required]),
      documentTypeCodeId: new FormControl(documentValue),
      photoCopyDocumentTypeCodeId: new FormControl(),
      originalDocumentTypeCodeId: new FormControl(),
      copyAttestationTypeCodeId: new FormControl(0),
      originalAttestationTypeCodeId: new FormControl(0),
      copyAttestationRateId: new FormControl(0),
      originalAttestationRateId: new FormControl(0),
      originalId: new FormControl(null),
      photocopyId: new FormControl(null),
    })
    attestationlist.push(newRow);
  }

  public submitAttestationDetails(index, type) {
    if (this.formView != 'view') {
      //-----------------------------------------------//
      //disabled form case
      if (this.degreeAttestationForm.value.degreeList[index].degree != undefined) {
        //-----------------------------------------------//
        //for local education submission
        if (this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.countryId == 1) {
          //-----------------------------------------------//
          //education is not verified or currently enrolled nor is incompleted
          if (!this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified && (
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isCAUniversity)) {
            //-----------------------------------------------//
            //if stamp number verified
            if (this.degreeStatus[index] == 1 && this.degreeStampVerified[index]) {
              if (this.degreeAttestationForm.value.degreeList[index].degree[1].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[2].originalPages != 0 ||
                this.degreeAttestationForm.value.degreeList[index].degree[3].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[0].photocopyPages != 0
                || this.degreeAttestationForm.value.degreeList[index].degree[1].photocopyPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[2].photocopyPages != 0
                || this.degreeAttestationForm.value.degreeList[index].degree[3].photocopyPages != 0) {
                this.isAttestationValid = true;
              }
            }
            //-----------------------------------------------//
            //if new degree
            else if (this.degreeAttestationForm.value.degreeList[index].degree[0].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[1].originalPages != 0 ||
              this.degreeAttestationForm.value.degreeList[index].degree[2].originalPages != 0) {
              if ((this.degreeAttestationForm.value.degreeList[index].degree[3].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[3].originalPages != undefined)) {
                this.isAttestationValid = true;
              }
            }

            // }
          }
          if (!this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified && (
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isCAUniversity) &&
            this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isPartiallyAttested) {
            //-----------------------------------------------//
            //if stamp number verified
            if (this.degreeStatus[index] == 1 && this.degreeStampVerified[index]) {
              if (this.degreeAttestationForm.value.degreeList[index].degree[1].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[2].originalPages != 0 ||
                this.degreeAttestationForm.value.degreeList[index].degree[3].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[0].photocopyPages != 0
                || this.degreeAttestationForm.value.degreeList[index].degree[1].photocopyPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[2].photocopyPages != 0
                || this.degreeAttestationForm.value.degreeList[index].degree[3].photocopyPages != 0) {
                this.isAttestationValid = true;
              }
            }
            //-----------------------------------------------//
            //if new degree
            else if (this.degreeAttestationForm.value.degreeList[index].degree[0].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[1].originalPages != 0 ||
              this.degreeAttestationForm.value.degreeList[index].degree[2].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[1].photocopyPages != 0) {
              if ((this.degreeAttestationForm.value.degreeList[index].degree[3].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[3].originalPages != undefined)) {
                this.isAttestationValid = true;
              }
            }

            // }
          }
          if (this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified && (
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isCAUniversity) &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isPartiallyAttested) {
            //-----------------------------------------------//
            //if stamp number verified
            if (this.degreeAttestationForm.value.degreeList[index].degree[0].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[1].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[2].originalPages != 0 ||
              this.degreeAttestationForm.value.degreeList[index].degree[3].originalPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[0].photocopyPages != 0
              || this.degreeAttestationForm.value.degreeList[index].degree[1].photocopyPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[2].photocopyPages != 0
              || this.degreeAttestationForm.value.degreeList[index].degree[3].photocopyPages != 0) {
              this.isAttestationValid = true;
            }
            // }
            //-----------------------------------------------//
          }
          //-----------------------------------------------//
          //if education is not verified and either currently enrolled or is incompleted
          else if (!this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isCAUniversity && (
              this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd ||
              this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation) &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isPartiallyAttested) {
            if (this.degreeAttestationForm.value.degreeList[index].degree[0].originalPages != 0) {
              this.isAttestationValid = true;
            }
          }
          else if (!this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isCAUniversity && (
              this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd ||
              this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation) &&
            this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isPartiallyAttested
          ) {
            if (this.degreeAttestationForm.value.degreeList[index].degree[0].originalPages != 0 ||
              this.degreeAttestationForm.value.degreeList[index].degree[0].photocopyPages != 0) {
              this.isAttestationValid = true;
            }
          }
          else if (!this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified &&
            this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isCAUniversity || (
              this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd ||
              this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation)) {
            for (let j = 0; j < this.degreeAttestationForm.value.degreeList[index].degree.length; j++) {
              if (this.degreeStatus[index] == 1 && this.degreeStampVerified[index]) {
                if (this.degreeAttestationForm.value.degreeList[index].degree[0].photocopyPages != 0) {
                  this.isAttestationValid = true;
                }
              } else if (this.degreeAttestationForm.value.degreeList[index].degree[0].originalPages != 0) {
                this.isAttestationValid = true;
              }
            }
          }
        }
        //-----------------------------------------------//
        //for international education
        else {
          if (!this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified && (
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd &&
            !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation)) {
            if (this.degreeStatus[index] == 1 && this.degreeStampVerified[index]) {

              if (this.degreeAttestationForm.value.degreeList[index].degree[0].photocopyPages != 0) {

                this.isAttestationValid = true;
              }
            } else if (this.degreeAttestationForm.value.degreeList[index].degree[0].originalPages != 0) {
              this.isAttestationValid = true;
            }

            // }
          } else if (!this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified && (
            this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd ||
            this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation)) {
            if (this.degreeStatus[index] == 1 && this.degreeStampVerified[index]) {
              if (this.degreeAttestationForm.value.degreeList[index].degree[0].photocopyPages != 0) {
                this.isAttestationValid = true;
              }
            } else if (this.degreeAttestationForm.value.degreeList[index].degree[0].originalPages != 0) {
              this.isAttestationValid = true;
            }

            // }
          }
          else if (this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified) {
            if (this.degreeAttestationForm.value.degreeList[index].degree[0].photocopyPages != 0 || this.degreeAttestationForm.value.degreeList[index].degree[0].originalPages != 0) {
              this.isAttestationValid = true;
            }

            // }
          }
        }
      }
      else if (this.degreeAttestationForm.value.degreeList[index].degree == undefined) {
        this.isAttestationValid = false;
        this.cdr.detectChanges();
      }

      else {
      }


      if (this.isAttestationValid) {
        this.isError[index] = false;
        this.isAttestationValid = false;
      } else {
        this.isError[index] = true;
        this.isAttestationValid = false;
        this.alertType = 'error';
        this.errorMsg = 'Please provide Number of Pages for Photocopy/Original Documents for at least one Degree/Transcript/Provisional Certificate/Equivalence Certificate'
        this.cdr.detectChanges();
        return;
      }
      if (this.degreeAttestationForm.value.degreeList.length == (index + 1)) {
        this.markFormsTouched(this.degreeAttestationForm)
        if (this.degreeAttestationForm.markAllAsTouched && this.degreeAttestationForm.valid) {
          let payload = this.constructPayload()
          if (payload.dasApplicationDto.applicationAttestationTypeId != 600184) {
            payload.dasApplicationDto.applicationAttestationTypeId = 600181
          }
          for (let i = 0; i < this.dasApplicationData.dasApplicationDto.dasDegrees.length; i++) {
            if (this.degreeStatus[i] == 0) {
              payload.dasApplicationDto.dasDegrees[i].applicationAttestationTypeId = 600181
            }
            if (!this.duplicateStatus[i]) {
              payload.dasApplicationDto.dasDegrees[i].applicationAttestationTypeId = 600181
            } else if (this.duplicateStatus[i]) {
              payload.dasApplicationDto.dasDegrees[i].applicationAttestationTypeId = 600184
            }
          }
          let requestpayload = {
            data: {
              dasApplicationDto: payload.dasApplicationDto
            }
          }
          if (this.formView == 'dasRevision') {
            requestpayload.data.dasApplicationDto['applicationStatusCodeId'] = 600827
          }
          this.loader = true;
          this.loaderService.setValue(this.loader)
          this.cdr.detectChanges();
          this.attestationService.saveApplicationData(requestpayload).subscribe(
            (res: HecResponse) => {
              if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
                this.loader = false
                this.loaderService.setValue(this.loader)
                this.cdr.detectChanges();
                if (type == 'next') {
                  this.goNext()
                } else if (type == 'cancel') {
                  this.router.navigate(['/dashboard'])
                }
              } else {
                this.loader = false
                this.loaderService.setValue(this.loader)
                this.cdr.detectChanges();
              }
            },
            (err) => {
              this.loader = false
              this.loaderService.setValue(this.loader)
              this.cdr.detectChanges();
            }
          )
        }else{
          window.scroll(0,0);
        }
      } else {
        this.nextStep()
      }
    } else {
      this.nextStep()

    }
  }

  public markFormsTouched(form): void {
    CommonHelper.markFormGroupTouched(form);
  }

  public cancelAttestaion() {
    this.router.navigate(['/dashboard'])
  }

  private constructPayload() {
    var dasDegrees = [];
    for (let i = 0; i < this.degreeAttestationForm.value.degreeList.length; i++) {
      if (this.dasApplicationData.dasApplicationDto.dasDegrees[i]['degreeInfo'].length > 0) {
        this.dasApplicationData.dasApplicationDto.dasDegrees[i]['degreeInfo'] = []
        for (let j = 0; j < this.degreeAttestationForm.value.degreeList[i].degree.length; j++) {

          if (this.degreeAttestationForm.value.degreeList[i].degree[j].originalPages > 0) {
            this.dasApplicationData.dasApplicationDto.dasDegrees[i]['degreeInfo'].push(
              {
                numberOfPages: this.degreeAttestationForm.value.degreeList[i].degree[j].originalPages,
                attestationRateId: this.degreeAttestationForm.value.degreeList[i].degree[j].originalAttestationRateId,
                id: this.degreeAttestationForm.value.degreeList[i].degree[j].originalId,
                attestationTypeCodeId: 60061,
                documentTypeCodeId: this.degreeAttestationForm.value.degreeList[i].degree[j].originalDocumentTypeCodeId,
              })
          }
          if (this.degreeAttestationForm.value.degreeList[i].degree[j].photocopyPages > 0) {
            this.dasApplicationData.dasApplicationDto.dasDegrees[i]['degreeInfo'].push(
              {
                numberOfPages: this.degreeAttestationForm.value.degreeList[i].degree[j].photocopyPages,
                attestationRateId: this.degreeAttestationForm.value.degreeList[i].degree[j].copyAttestationRateId,
                id: this.degreeAttestationForm.value.degreeList[i].degree[j].photocopyId,

                attestationTypeCodeId: 60062,
                documentTypeCodeId: this.degreeAttestationForm.value.degreeList[i].degree[j].photoCopyDocumentTypeCodeId,
              })

          }
        }
      } else {
        for (let j = 0; j < this.degreeAttestationForm.value.degreeList[i].degree.length; j++) {
          if (this.degreeAttestationForm.value.degreeList[i].degree[j].originalPages > 0) {
            this.dasApplicationData.dasApplicationDto.dasDegrees[i]['degreeInfo'].push(

              {
                numberOfPages: this.degreeAttestationForm.value.degreeList[i].degree[j].originalPages,
                attestationRateId: this.degreeAttestationForm.value.degreeList[i].degree[j].originalAttestationRateId,
                attestationTypeCodeId: 60061,
                documentTypeCodeId: this.degreeAttestationForm.value.degreeList[i].degree[j].originalDocumentTypeCodeId,

              })
          }
          if (this.degreeAttestationForm.value.degreeList[i].degree[j].photocopyPages > 0) {
            this.dasApplicationData.dasApplicationDto.dasDegrees[i]['degreeInfo'].push(
              {
                numberOfPages: this.degreeAttestationForm.value.degreeList[i].degree[j].photocopyPages,
                attestationRateId: this.degreeAttestationForm.value.degreeList[i].degree[j].copyAttestationRateId,
                attestationTypeCodeId: 60062,
                documentTypeCodeId: this.degreeAttestationForm.value.degreeList[i].degree[j].photoCopyDocumentTypeCodeId,
              })
          }

        }
        for (let g = 0; g < this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo.length; g++) {
          this.dasApplicationData.dasApplicationDto.dasDegrees[i]['degreeInfo'][g].id ? this.dasApplicationData.dasApplicationDto.dasDegrees[i]['degreeInfo'][g].id : null
        }
      }
      this.dasApplicationData.dasApplicationDto.dasDegrees[i].isDegreeAttestedBefore = this.degreeAttestationForm.value.degreeList[i].isDegreeAttestedBefore == "1" ? true : false
      this.dasApplicationData.dasApplicationDto.dasDegrees[i].stampNumber = this.degreeAttestationForm.value.degreeList[i].stampNumber;

    }
    this.dasApplicationData.dasApplicationDto.attestationMode = this.degreeAttestationForm.value.attestationMode
    if(this.degreeAttestationForm.value.attestationMode == 6003302){
      this.dasApplicationData.dasApplicationDto.isUrgent = true;
      this.dasApplicationData.dasApplicationDto.urgentFee = 5000;
    }else{
      this.dasApplicationData.dasApplicationDto.isUrgent = false;
      this.dasApplicationData.dasApplicationDto.urgentFee = 0;
    }
    if(this.degreeAttestationForm.value.attestationMode == 6003303){
      this.dasApplicationData.dasApplicationDto.isInsidePakistan = this.degreeAttestationForm.value.isInsidePakistan == 1?true:false;
      if(this.dasApplicationData.dasApplicationDto.isInsidePakistan){
      this.dasApplicationData.dasApplicationDto.regionalCentreId = this.regionalCenterByDistrict.value;
      this.dasApplicationData.dasApplicationDto.districtId = this.degreeAttestationForm.value.districtId;
    }else{
      this.dasApplicationData.dasApplicationDto.regionalCentreId = 1;

    }
      this.dasApplicationData.dasApplicationDto.submissionOptionCodeId = 60033
    }else {
      this.dasApplicationData.dasApplicationDto.regionalCentreId = this.degreeAttestationForm.value.regionalCentreId;

    }
    return this.dasApplicationData;

  }

  public setDataAttestationFormData() {
    if(this.dasApplicationData.dasApplicationDto.applicationStatusCodeId != 60081){
    if(this.dasApplicationData.dasApplicationDto.attestationMode == undefined && this.dasApplicationData.dasApplicationDto.isUrgent){
      this.dasApplicationData.dasApplicationDto.attestationMode = 6003302
    }else if(this.dasApplicationData.dasApplicationDto.attestationMode == undefined && !this.dasApplicationData.dasApplicationDto.isUrgent){
      this.dasApplicationData.dasApplicationDto.attestationMode = 6003301

    }
  }
    this.degreeAttestationForm.controls.attestationMode.patchValue(this.dasApplicationData.dasApplicationDto.attestationMode)
    this.getAttestationType(this.dasApplicationData.dasApplicationDto.attestationMode)

    if(this.dasApplicationData.dasApplicationDto.attestationMode == 6003303){
      this.getSendingDocPlace(this.dasApplicationData.dasApplicationDto.isInsidePakistan == true ? 1:2)
      this.degreeAttestationForm.controls.isInsidePakistan.patchValue(this.dasApplicationData.dasApplicationDto.isInsidePakistan == true ? "1":"2")
      if(this.dasApplicationData.dasApplicationDto.isInsidePakistan){
        this.degreeAttestationForm.controls.regionalCentreId.patchValue(this.dasApplicationData.dasApplicationDto.regionalCentreId)
        this.getRegionalCenterByDistrictId(this.dasApplicationData.dasApplicationDto.districtId)
        this.degreeAttestationForm.controls.districtId.patchValue(this.dasApplicationData.dasApplicationDto.districtId)
      }else if(!this.dasApplicationData.dasApplicationDto.isInsidePakistan){
        this.degreeAttestationForm.controls.regionalCentreId.patchValue(1)

      }
    }else{
    this.degreeAttestationForm.controls.regionalCentreId.patchValue(this.dasApplicationData.dasApplicationDto.regionalCentreId)
    }

    for (let degreeIndex = 0; degreeIndex < this.dasApplicationData.dasApplicationDto.dasDegrees.length; degreeIndex++) {
      if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo.length > 0) {

        this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].isDegreeAttestedBefore.patchValue(this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].isDegreeAttestedBefore == true ? "1" : "0")
        this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].stampNumber.patchValue(this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].stampNumber)
        this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].isDegreeDuplicateCase.patchValue(this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].applicationAttestationTypeId == 600184 ? "1" : "0")
        this.getDuplicateDegreeStatus(this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].applicationAttestationTypeId == 600184 ? 1 : 0, degreeIndex);
        if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.countryId == 1) {
          this.getDegreeStatus(this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].isDegreeAttestedBefore == true ? "1" : "0", degreeIndex, this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.countryId == 1, true)
        }
      }
    }
    this.attestationData = []
    for (let degreeIndex = 0; degreeIndex < this.dasApplicationData.dasApplicationDto.dasDegrees.length; degreeIndex++) {
      if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo.length > 0) {
        for (let attestationIndex = 0; attestationIndex < this.degreeAttestationForm.value.degreeList[degreeIndex].degree.length; attestationIndex++) {
          this.attestationData[attestationIndex] = {}
        }
      }
      // }
    }

    for (let degreeIndex = 0; degreeIndex < this.dasApplicationData.dasApplicationDto.dasDegrees.length; degreeIndex++) {
      if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo.length > 0) {

        for (let k = 0; k < this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo.length; k++) {
          if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.countryId == 1) {
            for (let attestationIndex = 0; attestationIndex < this.degreeAttestationForm.value.degreeList[degreeIndex].degree.length; attestationIndex++) {
              if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ==
                this.degreeAttestationForm.value.degreeList[degreeIndex].degree[attestationIndex].documentTypeCodeId &&
                this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId == 60061) {
                this.attestationData[attestationIndex] = Object.assign(this.attestationData[attestationIndex], {
                  originalPages: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages : 0,
                  originalDocValue: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId : 0,
                  originalAttestationType: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId : 0,
                  originalId: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id : null,
                });
                this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.originalId.patchValue(this.attestationData[attestationIndex].originalId ? this.attestationData[attestationIndex].originalId : null)
                this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.originalPages.patchValue(this.attestationData[attestationIndex].originalPages ? this.attestationData[attestationIndex].originalPages : 0)
                this.getDocumentPagesCount(this.attestationData[attestationIndex].originalPages, this.attestationData[attestationIndex].originalDocValue, this.attestationData[attestationIndex].originalAttestationType, attestationIndex, 'local', degreeIndex, 'filling')
              }

              else if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ==
                this.degreeAttestationForm.value.degreeList[degreeIndex].degree[attestationIndex].documentTypeCodeId &&
                this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId == 60062) {
                this.attestationData[attestationIndex] = Object.assign(this.attestationData[attestationIndex], {
                  photocopyPages: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages : 0,
                  photocopyValue: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId : 0,
                  copyAttestationType: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId : 0,
                  photocopyId: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id : null,

                });
                this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.photocopyId.patchValue(this.attestationData[attestationIndex].photocopyId ? this.attestationData[attestationIndex].photocopyId : null)

                this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.photocopyPages.patchValue(this.attestationData[attestationIndex].photocopyPages ? this.attestationData[attestationIndex].photocopyPages : 0)
                this.getDocumentPagesCount(this.attestationData[attestationIndex].photocopyPages, this.attestationData[attestationIndex].photocopyValue, this.attestationData[attestationIndex].copyAttestationType, attestationIndex, 'local', degreeIndex, 'filling')
              }
            }
          } else {
            for (let attestationIndex = 0; attestationIndex < this.degreeAttestationForm.value.degreeList[degreeIndex].degree.length; attestationIndex++) {
              if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ==
                this.degreeAttestationForm.value.degreeList[degreeIndex].degree[attestationIndex].documentTypeCodeId &&
                this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId == 60061) {
                this.attestationData[attestationIndex] = Object.assign(this.attestationData[attestationIndex], {
                  originalPages: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages : 0,
                  originalDocValue: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId : 0,
                  originalAttestationType: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId : 0,
                  originalId: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id : null,
                });
                this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.originalId.patchValue(this.attestationData[attestationIndex].originalId ? this.attestationData[attestationIndex].originalId : null)
                this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.originalPages.patchValue(this.attestationData[attestationIndex].originalPages ? this.attestationData[attestationIndex].originalPages : 0)
                this.getDocumentPagesCount(this.attestationData[attestationIndex].originalPages, this.attestationData[attestationIndex].originalDocValue, this.attestationData[attestationIndex].originalAttestationType, attestationIndex, 'int', degreeIndex, 'filling')
              }

              else if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ==
                this.degreeAttestationForm.value.degreeList[degreeIndex].degree[attestationIndex].documentTypeCodeId &&
                this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId == 60062) {
                this.attestationData[attestationIndex] = Object.assign(this.attestationData[attestationIndex], {
                  photocopyPages: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages : 0,
                  photocopyValue: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId : 0,
                  copyAttestationType: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId : 0,
                  photocopyId: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id : null,

                });
                this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.photocopyId.patchValue(this.attestationData[attestationIndex].photocopyId ? this.attestationData[attestationIndex].photocopyId : null)

                this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.photocopyPages.patchValue(this.attestationData[attestationIndex].photocopyPages ? this.attestationData[attestationIndex].photocopyPages : 0)
                this.getDocumentPagesCount(this.attestationData[attestationIndex].photocopyPages, this.attestationData[attestationIndex].photocopyValue, this.attestationData[attestationIndex].copyAttestationType, attestationIndex, 'int', degreeIndex, 'filling')
              }
            }
          }
        }
      }
    }
  }

  public ModalComponent(Component, verified, update, index, degreeIndex, degreeCase) {
    const dialogRef = this.matDialog.open(Component, {
      width: '40vw',
      height: '40vh',
      backdropClass: 'custom-scrutiny-popup',
      panelClass: 'custom-scrutiny-popup',
      disableClose: true,
      autoFocus: false,
      data: { verifiedCase: verified, updateCase: update }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result == 'duplicate' || result == 'noUpdate') {
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.originalPages.patchValue(0)
        } else if (result == 'new' && degreeCase == 'local') {
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[3].controls.originalPages.enable();
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].isDegreeAttestedBefore.patchValue(0)
        } else if (result == 'update') {
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].isDegreeAttestedBefore.patchValue(1)

        }
        else if (result == 'noDuplicate') {
          if (degreeCase == 'local') {
            this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[3].controls.originalPages.enable();
          }
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.originalPages.patchValue(0)
          this.amountForDegrees[degreeIndex].degreeList[index]['original'] = 0;

        }
      }
    });
  }

  public getDocumentPagesCount(value: number, docValue, attestationType, index, degreeCase, degreeIndex?, getValueType?) {
    //-----------------------------------------------//
    //for Degree local new complete education and no attested
    if (value == 1 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified &&
      index == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isCAUniversity
      && this.degreeStatus[degreeIndex] == 0 && degreeCase == 'local' && attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[3].controls.originalPages.enable();
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[0].controls.photocopyPages.enable();
    } else if (value == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified &&
      index == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isCAUniversity == false
      && this.degreeStatus[degreeIndex] == 0 && degreeCase == 'local' && attestationType == 60061 && getValueType == 'filling') {
      //-----------------------------------------------//
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[0].controls.photocopyPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[3].controls.originalPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[3].controls.photocopyPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[0].controls.photocopyPages.disable();
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[3].controls.originalPages.disable();
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[3].controls.photocopyPages.disable();
      this.amountForDegrees[degreeIndex].degreeList[0]['photocopy'] = 0;
      this.amountForDegrees[degreeIndex].degreeList[0]['original'] = 0;
      this.amountForDegrees[degreeIndex].degreeList[3]['photocopy'] = 0;
      this.amountForDegrees[degreeIndex].degreeList[3]['original'] = 0;
    }
    //-----------------------------------------------//
    //for Transcript local new complete education and no attested
    else if (value == 1 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified
      && index == 1 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isCAUniversity &&
      this.degreeStatus[degreeIndex] == 0 && degreeCase == 'local' && attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[1].controls.photocopyPages.enable();
    }
    else if (value == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified && index == 1
      && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd && this.degreeStatus[degreeIndex] == 0
      && degreeCase == 'local' && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isCAUniversity &&
      attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[1].controls.photocopyPages.disable();
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[1].controls.photocopyPages.patchValue(0);
      this.amountForDegrees[degreeIndex].degreeList[1]['photocopy'] = 0;
      this.amountForDegrees[degreeIndex].degreeList[1]['original'] = 0;
    }
    //-----------------------------------------------//
    //for Provisional Certifcate local new complete education and no attested
    else if (value == 1 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified
      && index == 2 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isCAUniversity &&
      this.degreeStatus[degreeIndex] == 0 && degreeCase == 'local' && attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[2].controls.photocopyPages.enable();
    }
    else if (value == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified && index == 2
      && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd && this.degreeStatus[degreeIndex] == 0
      && degreeCase == 'local' && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isCAUniversity &&
      attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[2].controls.photocopyPages.disable();
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[2].controls.photocopyPages.patchValue(0);
      this.amountForDegrees[degreeIndex].degreeList[2]['photocopy'] = 0;
      this.amountForDegrees[degreeIndex].degreeList[2]['original'] = 0;
    }
    //-----------------------------------------------//
    //for Equivalence Certifcate local new complete education and no attested
    else if (value == 1 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified
      && index == 3 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isCAUniversity &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      this.degreeStatus[degreeIndex] == 0 && degreeCase == 'local' && attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[3].controls.photocopyPages.enable();
    }
    else if (value == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified && index == 3
      && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd && this.degreeStatus[degreeIndex] == 0
      && degreeCase == 'local' && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isCAUniversity &&
      attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[3].controls.photocopyPages.disable();
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[3].controls.photocopyPages.patchValue(0);
      this.amountForDegrees[degreeIndex].degreeList[3]['photocopy'] = 0;
      this.amountForDegrees[degreeIndex].degreeList[3]['original'] = 0;
    }
    //-----------------------------------------------//
    else if (value == 1 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified
      && index == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isCAUniversity &&
      this.degreeStatus[degreeIndex] == 0 && degreeCase == 'local' && attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[0].controls.photocopyPages.enable();
    }
    else if (value == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified && index == 0 &&
      this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isCAUniversity &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd && this.degreeStatus[degreeIndex] == 0
      && degreeCase == 'local' && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[0].controls.photocopyPages.disable();
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[0].controls.photocopyPages.patchValue(0);
      this.amountForDegrees[degreeIndex].degreeList[0]['photocopy'] = 0;
      this.amountForDegrees[degreeIndex].degreeList[0]['original'] = 0;
    }
    //-----------------------------------------------//
    //for international new degree case no incomplete and not currently enrolled and no attested before
    if (value == 1 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      degreeCase == 'int' && attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.enable();
    } else if (value == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation &&
      degreeCase == 'int' && attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.originalPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.photocopyPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.photocopyPages.disable();
      this.amountForDegrees[degreeIndex].degreeList[index]['photocopy'] = 0;
      this.amountForDegrees[degreeIndex].degreeList[index]['original'] = 0;
    }
    //-----------------------------------------------//
    //duplicate Case
    else if (value == 1 && this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified && index == 0 && attestationType == 60061 && getValueType == 'filling') {
      this.duplicateStatus[degreeIndex] = true;
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].isDegreeDuplicateCase.setValidators([Validators.required]);
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].isDegreeDuplicateCase.updateValueAndValidity()
      this.cdr.detectChanges()
    }
    else if (value == 0 && this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified && index == 0 && attestationType == 60061 && getValueType == 'filling') {
      this.duplicateStatus[degreeIndex] = false;
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].isDegreeDuplicateCase.setValidators(null);
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].isDegreeDuplicateCase.updateValueAndValidity()
    }
    //-----------------------------------------------//
    //for Local Incomplete/currently enrolled education
    else if (value == 1 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified && index == 0
      && degreeCase == 'local' && (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd || this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation) &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isPartiallyAttested &&
      attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.enable();
    }
    else if (value == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified && index == 0 &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isPartiallyAttested &&
      (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd || this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation)
      && degreeCase == 'local' && attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[0].controls.photocopyPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[0].controls.photocopyPages.disable();
      this.amountForDegrees[degreeIndex].degreeList[0]['photocopy'] = 0;
      this.amountForDegrees[degreeIndex].degreeList[0]['original'] = 0;
    }
    else if (value == 1 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified && index == 0
      && degreeCase == 'local' && (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd || this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation) &&
      this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isPartiallyAttested &&
      attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.enable();
    }
    else if (value == 0 && !this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.verified && index == 0 &&
      this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isPartiallyAttested &&
      (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.currentEnrolmentInd || this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.isIncompleteEducation)
      && degreeCase == 'local' && attestationType == 60061 && getValueType == 'filling') {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.enable();
      this.amountForDegrees[degreeIndex].degreeList[0]['original'] = 0;
    }

    for (let i = 0; i < this.attestationRates.length; i++) {
      if (this.attestationRates[i].documentTypeCodeId == docValue &&
        this.attestationRates[i].attestationTypeCodeId == attestationType) {
        if (attestationType == 60061) {
          this.amountForDegrees[degreeIndex].degreeList[index]['original'] = null;
          this.amountForDegrees[degreeIndex].degreeList[index]['original'] = this.amountForDegrees[degreeIndex].degreeList[index]['original'] == null ? (this.attestationRates[i].rate * value) : Number(this.amountForDegrees[degreeIndex].degreeList[index]['original'] + (this.attestationRates[i].rate * value));
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.originalAttestationTypeCodeId.patchValue(attestationType)
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.originalDocumentTypeCodeId.patchValue(docValue)
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.originalAttestationRateId.patchValue(this.attestationRates[i].id)
        } else {
          this.amountForDegrees[degreeIndex].degreeList[index]['photocopy'] = null;
          this.amountForDegrees[degreeIndex].degreeList[index]['photocopy'] = this.amountForDegrees[degreeIndex].degreeList[index] == null ? (this.attestationRates[i].rate * value) : this.amountForDegrees[degreeIndex].degreeList[index]['photocopy'] + (this.attestationRates[i].rate * value);
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.copyAttestationTypeCodeId.patchValue(attestationType)
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.photoCopyDocumentTypeCodeId.patchValue(docValue)
          this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[index].controls.copyAttestationRateId.patchValue(this.attestationRates[i].id)
        }
      }

    }
    this.getTotalAmount()
  }

  public getTotalAmount() {
    if (this.amountForDegrees.length > 0) {
      for (let i = 0; i < this.amountForDegrees.length; i++) {
        for (let j = 0; j < this.amountForDegrees[i].degreeList.length; j++) {
          this.totalForLocal = this.amountForDegrees[i].degreeList.reduce(function (previousValue, currentValue) {
            return {
              original: previousValue.original + currentValue.original,
              photocopy: previousValue.photocopy + currentValue.photocopy
            }
          });
        }
        this.totalAmountForDegrees[i] = Number(this.totalForLocal.original + this.totalForLocal.photocopy)
      }
    }
  }

  public getDegreeStatus(beforeValue, index, degreeCase, isGet?) {
    this.degreeStatus[index] = beforeValue
    if (degreeCase && !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation &&
      !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isCAUniversity) {
      if (isGet == undefined) {
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.reset();
      }
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.originalPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[1].controls.originalPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[2].controls.originalPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[3].controls.originalPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.photocopyPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[1].controls.photocopyPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[2].controls.photocopyPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[3].controls.photocopyPages.patchValue(0);
      this.amountForDegrees[index].degreeList[0]['photocopy'] = 0;
      this.amountForDegrees[index].degreeList[1]['photocopy'] = 0;
      this.amountForDegrees[index].degreeList[2]['photocopy'] = 0;
      this.amountForDegrees[index].degreeList[3]['photocopy'] = 0;
      this.amountForDegrees[index].degreeList[0]['original'] = 0;
      this.amountForDegrees[index].degreeList[1]['original'] = 0;
      this.amountForDegrees[index].degreeList[2]['original'] = 0;
      this.amountForDegrees[index].degreeList[3]['original'] = 0;
    } else if (degreeCase && (this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd ||
      this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation)) {
      if (isGet == undefined) {

        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.reset();
      }
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.originalPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.photocopyPages.patchValue(0);
      this.amountForDegrees[index].degreeList[0]['original'] = 0;
      this.amountForDegrees[index].degreeList[0]['photocopy'] = 0;
    }
    else {
      if (isGet == undefined) {
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.reset();
      }
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.originalPages.patchValue(0);
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.photocopyPages.patchValue(0);
      this.amountForDegrees[index].degreeList[0]['photocopy'] = 0;
      this.amountForDegrees[index].degreeList[0]['original'] = 0;

    }
    this.getTotalAmount()
    if (this.degreeStatus[index] == 1 && !this.degreeStampVerified[index] && !isGet) {
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.disable();
    } else if (this.degreeStatus[index] == 0) {
      if (degreeCase == true && !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isCAUniversity) {
        this.degreeStampVerified[index] = false
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].stampNumber.reset()
        if (!this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation) {
          this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.enable();
          if (!this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified) {
            this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[3].controls.originalPages.disable();
            this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.photocopyPages.disable();
            this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[1].controls.photocopyPages.disable();
            this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[2].controls.photocopyPages.disable();
            this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[3].controls.photocopyPages.disable();
          } else {

          }
        } else if ((this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd == true ||
          this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation == true) &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isPartiallyAttested
        ) {
          this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.enable();
          this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.photocopyPages.disable();
        }
        else if (this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd == true ||
          this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation == true &&
          this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isPartiallyAttested
        ) {
          this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.enable();
        }
        if (this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isPartiallyAttested &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd) {
          this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[1].controls.photocopyPages.enable();
          this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[2].controls.photocopyPages.enable();
          this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.originalPages.enable();
        }
      } else if (!degreeCase) {
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.enable();
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.enable();
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.photocopyPages.disable();
        if (this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isPartiallyAttested == true &&
          !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.verified) {
          this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[1].controls.photocopyPages.enable();
        }
      } else {
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.enable();
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.photocopyPages.disable();
      }
    } else if (this.degreeStatus[index] == 1 && isGet) {
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.enable();
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.originalPages.disable()
    }

  }

  public getDuplicateDegreeStatus(e, index) {
    if (this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.countryId == 1) {
      this.duplicateStatus[index] = e == 1 ? true : false;
    }
    if (e == 1) {
      this.dasApplicationData.dasApplicationDto.applicationAttestationTypeId = 600184
      this.dasApplicationData.dasApplicationDto.dasDegrees[index].applicationAttestationTypeId = 600184
    } else {
      this.dasApplicationData.dasApplicationDto.dasDegrees[index].applicationAttestationTypeId = 600181
      this.dasApplicationData.dasApplicationDto.applicationAttestationTypeId = 600181
      this.duplicateStatus[index] = false;
      if (this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.countryId == 1) {
        this.amountForDegrees[index].degreeList[0]['original'] = 0;
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.originalPages.patchValue(0);
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].isDegreeDuplicateCase.reset()
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].isDegreeDuplicateCase.setValidators(null);
        this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].isDegreeDuplicateCase.updateValueAndValidity()
      }
      this.getTotalAmount();
    }
  }

  public validateStampNumber(i) {
    let stampNumber = this.degreeAttestationForm.value.degreeList[i].stampNumber
    this.attestationService.validateStampNumber(stampNumber).subscribe(
      (res: HecResponse) => {
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          if (res.data) {
            this.isError[i] = false;
            this.degreeStampVerified[i] = res.data;
            this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.enable();
            this.degreeAttestationForm.controls.degreeList['controls'][i]['controls'].degree.controls[0].controls.originalPages.disable();
          } else {
            this.degreeAttestationForm.controls.degreeList['controls'][i].controls.stampNumber.setErrors({ max: true })
            this.isError[i] = true;
            this.alertType = 'error';
            this.errorMsg = 'Incorrect Stamp Number'
          }
        }
      }
    )
  }

  public getAttestationType(value,type?){
    this.attestationMode = value
    if(value !== 6003303){
      this.degreeAttestationForm.get('regionalCentreId').setValidators([Validators.required]);
      this.degreeAttestationForm.get('regionalCentreId').updateValueAndValidity()
      this.degreeAttestationForm.get('isInsidePakistan').setValidators(null);
      this.degreeAttestationForm.controls.isInsidePakistan.reset();
      this.degreeAttestationForm.controls.regionalCentreId.reset();
			this.degreeAttestationForm.get('isInsidePakistan').updateValueAndValidity()
    }else if(value == 6003303){
      this.degreeAttestationForm.get('isInsidePakistan').setValidators([Validators.required]);
      this.degreeAttestationForm.get('isInsidePakistan').updateValueAndValidity()
      this.degreeAttestationForm.get('regionalCentreId').setValidators(null);
      this.degreeAttestationForm.get('regionalCentreId').updateValueAndValidity()
      this.degreeAttestationForm.controls.isInsidePakistan.reset();
      this.degreeAttestationForm.controls.regionalCentreId.reset();
    }
    this.isInsidePakistanSelected = undefined;
    this.regionalCenterByDistrict = undefined;
  }

  public getSendingDocPlace(value){
    this.isInsidePakistanSelected = value
    this.cdr.detectChanges();
    if(value == 1){
      this.getDistrictList()
      this.degreeAttestationForm.get('districtId').setValidators([Validators.required]);
      this.degreeAttestationForm.get('districtId').updateValueAndValidity()
      this.degreeAttestationForm.controls.districtId.reset();
    }else{
      this.degreeAttestationForm.controls.districtId.reset();

      this.degreeAttestationForm.get('districtId').setValidators(null);
      this.degreeAttestationForm.get('districtId').updateValueAndValidity()
    }

  }

  public getDistrictList():void{
    this.loader= true;
    this.loaderService.setValue((this.loader))
    this.attestationService.DistrictList().subscribe(
      (res:HecResponse)=>{
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
          this.districtList = res.data;
          this.loader= false;
          this.loaderService.setValue((this.loader))
          this.cdr.detectChanges();
        }
      }
    )
  }

  public getRegionalCenterByDistrictId(id):void{
    this.attestationService.getRegionalCentreByDistrictId(id).subscribe(
      (res:HecResponse)=>{
        this.loader= true;
        this.loaderService.setValue((this.loader))
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
          this.regionalCenterByDistrict = res.data;
          this.loader= false;
          this.loaderService.setValue((this.loader))
          this.cdr.detectChanges();
        }
      }
    )
  }

}


